import React from "react";
import { Instagram, Twitter, Phone, Mail } from "lucide-react";
import { COMPANY, LOGO_EMBLEM } from "@/data";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Our Fleet", href: "#fleet" },
  { label: "Experience", href: "#experience" },
  { label: "Contact", href: "#contact" },
  { label: "Book Online", href: "#book" },
];

export const Footer = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer className="border-t border-white/10 bg-background" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-6 py-20 lg:px-10">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img src={LOGO_EMBLEM} alt="Admiral emblem" className="h-12 w-12 object-contain" />
              <div className="font-serif text-3xl tracking-[0.3em] text-white">{COMPANY.short}</div>
            </div>
            <p className="mt-6 max-w-sm font-serif text-2xl font-light italic leading-snug text-zinc-400">
              Ride in style, arrive in excellence.
            </p>
            <div className="mt-8 flex gap-4">
              <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="footer-instagram" className="flex h-11 w-11 items-center justify-center border border-white/15 text-white transition-colors duration-300 hover:border-primary hover:text-primary">
                <Instagram className="h-4 w-4" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" data-testid="footer-twitter" className="flex h-11 w-11 items-center justify-center border border-white/15 text-white transition-colors duration-300 hover:border-primary hover:text-primary">
                <Twitter className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-600">Company</p>
            <ul className="mt-6 space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <button onClick={() => go(n.href)} className="text-sm text-zinc-300 transition-colors duration-300 hover:text-primary">
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-600">Get in Touch</p>
            <ul className="mt-6 space-y-3">
              {COMPANY.phones.map((p) => (
                <li key={p.tel}>
                  <a href={`tel:${p.tel}`} className="flex items-center gap-3 text-sm text-zinc-300 transition-colors duration-300 hover:text-primary">
                    <Phone className="h-3.5 w-3.5 text-primary" /> <span className="text-zinc-500">{p.label}:</span> {p.number}
                  </a>
                </li>
              ))}
              <li>
                <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 pt-1 text-sm text-zinc-300 transition-colors duration-300 hover:text-primary">
                  <Mail className="h-3.5 w-3.5 text-primary" /> {COMPANY.email}
                </a>
              </li>
              <li className="pt-2 text-sm text-zinc-500">{COMPANY.address}</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-xs text-zinc-600 md:flex-row md:items-center">
          <span>© {new Date().getFullYear()} Admiral Limo INC. All Rights Reserved.</span>
          <span>Booking &amp; cancellation policy applies to all reservations.</span>
        </div>
      </div>
    </footer>
  );
};
